import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from '@kyruus/intl';

// Import styled component from styles.js
import { Container } from './styles';

const messages = defineMessages({
  providerFoundWithSearch: {
    id: 'search.summary.providerFoundWithSearch',
    description: 'Text displayed when providers are found with a search term',
    defaultMessage:
      '{providerCount} {providerCount, plural, one {provider} other {providers}} found for "{searchTerm}" at {locationName}'
  },
  providerFound: {
    id: 'search.summary.providerFound',
    description:
      'Text displayed when providers are found without a search term',
    defaultMessage:
      '{providerCount} {providerCount, plural, one {provider} other {providers}} found at {locationName}'
  },
  resultsSummary: {
    id: 'search.summary.aria.label',
    description: 'Aria label for results container',
    defaultMessage: 'Results summary'
  }
});

/**
 * SearchSummary component displays a text summary of the search results
 * Shows the number of providers found at the selected location
 */
const SearchSummary = ({ providerCount, searchTerm, locationName }) => {
  const intl = useIntl();

  if (!providerCount || !locationName) {
    return null;
  }

  const messageDescriptor = searchTerm
    ? messages.providerFoundWithSearch
    : messages.providerFound;

  const ariaLabel = intl.formatMessage(messages.resultsSummary);

  return (
    <Container role="status" aria-live="polite" aria-label={ariaLabel}>
      <FormattedMessage
        {...messageDescriptor}
        values={{
          providerCount,
          searchTerm,
          locationName
        }}
      />
    </Container>
  );
};

SearchSummary.propTypes = {
  providerCount: PropTypes.number.isRequired,
  searchTerm: PropTypes.string,
  locationName: PropTypes.string.isRequired
};

SearchSummary.defaultProps = {
  searchTerm: ''
};

export default SearchSummary;
